var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stageHolder"},[_c('div',{staticClass:"child",style:({ height: _vm.lineheight + 'px' })},[_c('div',{staticClass:"childTitle stageTitle",style:({ top: _vm.lineheight - 16 + 'px' }),on:{"contextmenu":function($event){$event.preventDefault();}}},[_vm._v("\n      "+_vm._s(_vm.$t('Diary'))+"\n    ")])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d8d8da7","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/projectplan/DiaryTitle.vue
// module id = 1595
// module chunks = 1